import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signOut } from '../pages/auth/services/signin/slice';
import { removeToken, isAdmin } from '../utils/auth';

const Sidebar: React.FC<{ onNavigate?: () => void }> = ({ onNavigate }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const admin = isAdmin();

  const handleLogout = () => {
    removeToken();
    dispatch(signOut());
    navigate('/');
  };

  return (
    <div className="left_col scroll-view" style={{ height: '100%' }}>
      {/* Brand / Logo */}
      <div
        style={{
          padding: '20px 15px 15px',
          textAlign: 'center',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          marginBottom: 8,
        }}
      >
        <img
          src="/images/mainLogoWeb.png"
          alt="EV Care"
          style={{
            width: 110,
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto 10px',
            filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.4))',
          }}
        />
       
      </div>

     
 <div
          style={{
            color: '#1abb9c',
            fontWeight: 700,
            fontSize: 16,
            letterSpacing: 1,
            textTransform: 'uppercase',
            textAlign: 'center'
          }}
        >
          EV Care Admin
        </div>
      <br />

      {/* Sidebar Menu */}
      <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
        <div className="menu_section">
           
          <ul className="nav side-menu">

            {/* Admin-only */}
            {admin && (
              <>
                <li>
                  <NavLink to="/admin/vendor-payments" onClick={onNavigate}>
                    <i className="bi bi-currency-rupee" />
                    <span>Vendor Payment Report</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/charger-status" onClick={onNavigate}>
                    <i className="bi bi-ev-station" />
                    <span>Charger Status Analytics</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/vendor-commission" onClick={onNavigate}>
                    <i className="bi bi-percent" />
                    <span>Vendor Commission</span>
                  </NavLink>
                </li>
              </>
            )}

            {/* Vendor (and admin)
            <li>
              <NavLink to="/vendor/charger-status" onClick={onNavigate}>
                <i className="bi bi-plug" />
                <span>My Charger Status</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink to="/vendor/charging-report" onClick={onNavigate}>
                <i className="bi bi-file-earmark-bar-graph" />
                <span>Charging Report</span>
              </NavLink>
            </li>

          </ul>
        </div>
      </div>

      {/* Sidebar footer */}
      <div className="sidebar-footer hidden-small">
        <button
          onClick={handleLogout}
          title="Logout"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '10px 15px',
            color: '#c4cfda',
            fontSize: 16,
          }}
        >
          <i className="fas fa-power-off" aria-hidden="true" />
          <span style={{ marginLeft: 8, fontSize: 13 }}>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
